import {
  arqApiAdmin,
  PostAdminQuestionsUploadsXlsxApiResponse,
} from 'src/redux/openapi';

const adminApi = arqApiAdmin.injectEndpoints({
  endpoints: (build) => ({
    postApiAdminQuestionsUploadsXlsx: build.mutation<
    PostAdminQuestionsUploadsXlsxApiResponse,
    PostAdminQuestionsUploadsXlsxApiArg
    >({
      query: (args) => ({
        url: `/api/admin/questions/uploads/xlsx`,
        method: 'POST',
        body: args.file,
      }),
    }),
    patchAdminApproveSubdomain: build.mutation<
    { message: string; data: { subdomain: string } },
    string
    >({
      query: (organizationId) => ({
        url: `/api/admin/organizations/${organizationId}/custom-login/subdomain/approve`,
        method: 'PATCH',
      }),
    }),
    patchAdminDeclineSubdomain: build.mutation<{ message: string }, string>({
      query: (organizationId) => ({
        url: `/api/admin/organizations/${organizationId}/custom-login/subdomain/decline`,
        method: 'PATCH',
      }),
    }),
  }),
  overrideExisting: true,
});

type PostAdminQuestionsUploadsXlsxApiArg = {
  file: FormData;
};

export const {
  usePostApiAdminQuestionsUploadsXlsxMutation:
    usePostAdminQuestionsUploadsXlsxMutation,
  usePatchAdminApproveSubdomainMutation,
  usePatchAdminDeclineSubdomainMutation,
} = adminApi;
